// VFX: Achievement Badge Unlock
// Category: ui-elements · Tags: badge, achievement, unlock, gamification, pop
// Badge icon pops with scale spring + confetti burst.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate, random } from "remotion";
import React from "react";

const CONFETTI_COUNT = 36;

export default function CardAchievementBadgeUnlock700Ms() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const pop = spring({ frame, fps, config: { stiffness: 220, damping: 12, mass: 0.7 } });
  const ringPulse = spring({ frame: frame - 4, fps, config: { stiffness: 120, damping: 15 } });
  const confetti = interpolate(frame, [4, 30], [0, 1], { extrapolateRight: "clamp" });

  return (
    <AbsoluteFill style={{
      background: "radial-gradient(circle at 50% 45%, #1e1b4b 0%, #0a0e1a 100%)",
      justifyContent: "center", alignItems: "center",
    }}>
      {/* Outer pulse rings */}
      {[0, 0.2, 0.4].map((d, i) => {
        const r = interpolate(Math.max(0, ringPulse - d), [0, 1], [0, 320 + i * 40]);
        const o = interpolate(Math.max(0, ringPulse - d), [0, 1], [0.5, 0]);
        return (
          <div key={i} style={{
            position: "absolute",
            width: r, height: r, borderRadius: "50%",
            border: "3px solid #f97316",
            opacity: o,
          }} />
        );
      })}

      {/* Confetti */}
      {Array.from({ length: CONFETTI_COUNT }).map((_, i) => {
        const angle = (i / CONFETTI_COUNT) * Math.PI * 2;
        const dist = interpolate(confetti, [0, 1], [0, 260 + random(`d-${i}`) * 80]);
        const fall = Math.pow(confetti, 2) * 60;
        const x = Math.cos(angle) * dist;
        const y = Math.sin(angle) * dist + fall;
        const rot = confetti * 720 + i * 30;
        const colors = ["#f97316", "#a855f7", "#06b6d4", "#10b981", "#ef4444"];
        return (
          <div key={i} style={{
            position: "absolute",
            transform: `translate(${x}px, ${y}px) rotate(${rot}deg)`,
            width: 10, height: 14,
            background: colors[i % colors.length],
            borderRadius: 2,
            opacity: interpolate(confetti, [0, 0.1, 0.9, 1], [0, 1, 1, 0]),
          }} />
        );
      })}

      {/* Badge */}
      <div style={{
        transform: `scale(${pop})`,
        width: 200, height: 200, borderRadius: "50%",
        background: "linear-gradient(135deg, #f97316 0%, #fbbf24 60%, #f97316 100%)",
        display: "flex", justifyContent: "center", alignItems: "center",
        boxShadow: "0 12px 40px rgba(249,115,22,0.55), inset 0 4px 0 rgba(255,255,255,0.4), inset 0 -4px 0 rgba(0,0,0,0.2)",
        border: "6px solid #fde68a",
      }}>
        <span style={{ fontSize: 96, lineHeight: 1, filter: "drop-shadow(0 4px 6px rgba(0,0,0,0.3))" }}>★</span>
      </div>

      <p style={{
        position: "absolute", bottom: "30%",
        margin: 0, fontSize: 42, fontWeight: 800, color: "#f8fafc",
        fontFamily: "sans-serif", letterSpacing: 2,
        opacity: interpolate(frame, [10, 22], [0, 1], { extrapolateRight: "clamp" }),
        transform: `translateY(${interpolate(frame, [10, 22], [12, 0], { extrapolateRight: "clamp" })}px)`,
      }}>UNLOCKED</p>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
